import { ShoppingBag } from "lucide-react";

export const LEVELS = [
  { n: 1, code: "N1", label: "Novice" },
  { n: 2, code: "N2", label: "Débrouillé" },
  { n: 3, code: "N3", label: "Averti" },
  { n: 4, code: "N4", label: "Expert" },
];

export function Logo({ size = "md" }) {
  const s = size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const t = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className={`${s} rounded-2xl bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-sm shadow-orange-200 rotate-[-6deg]`}>
        <ShoppingBag className="h-1/2 w-1/2 text-white" strokeWidth={2.5} />
      </div>
      <div className="leading-none">
        <span className={`font-display font-600 ${t} text-slate-900`} style={{ fontWeight: 600 }}>
          Merry<span className="text-orange-500">Zone</span>
        </span>
        <span className="block text-[11px] text-slate-400 font-semibold -mt-0.5">le magasin du lycée</span>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  if (status === "vue")
    return <span data-testid="status-vue" className="bg-sky-100 text-sky-700 px-2.5 py-1 rounded-full text-[10px] font-extrabold uppercase tracking-wide">Vue</span>;
  if (status === "en_cours")
    return <span data-testid="status-encours" className="bg-orange-100 text-orange-700 px-2.5 py-1 rounded-full text-[10px] font-extrabold uppercase tracking-wide">En cours</span>;
  return <span className="bg-slate-100 text-slate-500 px-2.5 py-1 rounded-full text-[10px] font-extrabold uppercase tracking-wide">À venir</span>;
}

const LEVEL_COLORS = {
  1: "bg-slate-200 text-slate-600",
  2: "bg-sky-200 text-sky-800",
  3: "bg-orange-200 text-orange-800",
  4: "bg-orange-500 text-white",
};

export function LevelPill({ level }) {
  const l = LEVELS[level - 1];
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${LEVEL_COLORS[level]}`}>
      {l.code} {l.label}
    </span>
  );
}

export function ProgressBar({ value, max = 100, className = "" }) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div className={`bg-slate-100 rounded-full h-3 overflow-hidden ${className}`}>
      <div className="bg-orange-500 h-full rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
    </div>
  );
}

export function yearLabel(y) {
  return y === 1 ? "1re année" : "2e année";
}

// Classes for the round séance number/check badge, by class-level status.
export function seanceIconClass(status) {
  if (status === "vue") return "bg-sky-100 text-sky-600";
  if (status === "en_cours") return "bg-orange-500 text-white";
  return "bg-slate-100 text-slate-400";
}

export function BlocSwitcher({ sequences, value, onChange }) {
  if (!sequences || sequences.length < 2) return null;
  const showYear = new Set(sequences.map((s) => s.year)).size > 1;
  return (
    <div className="inline-flex items-center gap-1 bg-slate-100 rounded-full p-1" data-testid="bloc-switcher">
      {sequences.map((s) => (
        <button
          key={s.id}
          onClick={() => onChange(s.id)}
          data-testid={`bloc-tab-${s.id}`}
          className={`px-4 py-2 rounded-full text-sm font-bold transition-colors ${
            value === s.id ? "bg-white text-orange-600 shadow-sm" : "text-slate-500 hover:text-slate-800"
          }`}
        >
          {showYear ? `${s.bloc} · ${s.year === 1 ? "1re" : "2e"}` : s.bloc}
        </button>
      ))}
    </div>
  );
}
